"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Button = ({
  className,
  background,
  label,
  size,
  variant,
  fullWidth,
  icon,
  disabled,
  ...rest
}) => {
  let baseClass = "sp-button";
  let buttonClasses = (0, _classnames.default)(className, `${baseClass}`, `${baseClass}--${size}`, `${baseClass}--${variant}-${background}`, {
    "sp-w-100": fullWidth,
    "sp-button--icon": icon
  });
  let remixIconClasses = (0, _classnames.default)(icon, "icon", "sp-ml--8");
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    className: buttonClasses,
    disabled: disabled
  }, rest), label, icon && /*#__PURE__*/_react.default.createElement("i", {
    className: remixIconClasses
  }));
};

exports.Button = Button;
Button.defaultProps = {
  size: "sm",
  variant: "primary"
};
Button.propTypes = {
  className: _propTypes.default.string,
  background: _propTypes.default.oneOf(_utils.enums.colors),
  label: _propTypes.default.string.isRequired,
  size: _propTypes.default.oneOf(_utils.enums.sizes),
  variant: _propTypes.default.oneOf(_utils.enums.buttonVariants),
  fullWidth: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.string,
  type: _propTypes.default.string
};
var _default = Button;
exports.default = _default;